import { createContext, useContext, useState } from "react";

export const LOOKBOOK_IMAGES = [
  "https://images.unsplash.com/photo-1779675787758-ab13c8e3576d?auto=format&fit=crop&q=85",
  "https://images.unsplash.com/photo-1779675787607-e31e4926f267?auto=format&fit=crop&q=85",
  "https://images.unsplash.com/photo-1769458711041-554e51a58cb1?auto=format&fit=crop&q=85",
];

export const translations = {
  en: {
    nav: {
      home: "HOME",
      collection: "SHOP",
      contact: "CONTACT",
    },
    hero: {
      line1: "THERE'S NO LOSING.",
      line2: "ONLY LEARNING OR",
      scriptWord: "Winning",
      cta: "EXPLORE DROP 001",
      scroll: "SCROLL",
    },
    products: {
      title: "BUILT FOR THE RELENTLESS",
      collectionTitle: "FULL COLLECTION",
      viewAll: "FULL COLLECTION",
      comingSoon: "Full collection drops soon. Join the club to get notified.",
      colour: "Colour",
      colours: "Colours",
      empty: "NEW DROP COMING SOON",
      loadError: "PRODUCTS TEMPORARILY UNAVAILABLE",
    },
    product: {
      back: "BACK",
      addToCart: "ADD TO CART",
      notFound: "PRODUCT NOT FOUND",
      notFoundSub: "This piece is gone or never existed.",
    },
    contact: {
      title: "CONTACT",
      follow: "FOLLOW US",
      formName: "NAME",
      formEmail: "EMAIL",
      formMessage: "MESSAGE",
      send: "SEND MESSAGE",
      sending: "SENDING...",
      success: "Message sent. We'll get back to you soon.",
      error: "Something went wrong. Try again.",
    },
    lookbook: {
      title: "THE ARCHITECTURE OF WINNING",
      text: "Shot on concrete. Built for movement. Every stitch is a decision to go forward.",
    },
    social: {
      title: "OUR SOCIALS",
      sub: "Video reels from our ambassadors are coming soon. Tag #WINORWINS to get featured.",
      comingSoon: "VIDEO SOON",
      channels: [
        { platform: "INSTAGRAM", handle: "@winorwins.co", link: "https://instagram.com/winorwins.co" },
        { platform: "TIKTOK", handle: "@winorwins.co", link: "https://tiktok.com/@winorwins.co" },
      ],
    },
    cart: {
      title: "YOUR CART",
      empty: "YOUR CART IS EMPTY",
      subtotal: "SUBTOTAL",
      checkout: "CHECKOUT",
      discountPlaceholder: "Discount code",
      apply: "APPLY",
      remove: "REMOVE",
      soldOut: "SOLD OUT",
      added: "Added to cart.",
      unavailable: "This product is currently unavailable.",
      error: "Something went wrong. Try again.",
      discountApplied: "Discount applied",
      discountInvalid: "Invalid discount code",
      shippingNote: "Shipping calculated at checkout.",
      secure: "SECURE CARD PAYMENT — TEYA",
    },
    checkout: {
      title: "CHECKOUT",
      contact: "CONTACT",
      email: "E-mail",
      phone: "Phone",
      delivery: "DELIVERY ADDRESS",
      firstName: "First name",
      lastName: "Last name",
      address1: "Street and number",
      address2: "Apartment, floor (optional)",
      city: "City",
      zip: "Postal code",
      country: "Country",
      shipping: "SHIPPING",
      shippingHint: "Fill in your address to see shipping options.",
      shippingNone: "We can't ship to this address. Check it or contact us.",
      summary: "ORDER SUMMARY",
      subtotal: "SUBTOTAL",
      discount: "DISCOUNT",
      shippingCost: "SHIPPING",
      free: "FREE",
      total: "TOTAL",
      pay: "PAY",
      paying: "REDIRECTING TO PAYMENT…",
      agree: "By paying you agree to the",
      terms: "Terms & Conditions",
      and: "and",
      privacy: "Privacy Policy",
      secure: "Card payment is processed securely by Teya.",
      empty: "YOUR CART IS EMPTY",
      backToShop: "BACK TO SHOP",
      cancelled: "Payment cancelled. You can try again.",
      soldOut: "Something in your cart just sold out. Check your cart.",
      unavailable: "Payments are not available right now. Try again later.",
      error: "Something went wrong. Check your details and try again.",
      checking: "CHECKING PAYMENT…",
      paidTitle: "THANK YOU",
      paidText: "Payment received. Order confirmation is on its way to",
      order: "ORDER",
      pendingText: "We're still waiting for the bank to confirm the payment. We'll e-mail you as soon as it's confirmed.",
      failedTitle: "PAYMENT FAILED",
      failedText: "Your card was not charged. Try again or use a different card.",
      expiredTitle: "PAYMENT EXPIRED",
      tryAgain: "TRY AGAIN",
      boxChoose: "CHOOSE A BOX",
      boxChange: "CHANGE",
      boxHint: "Pick the DPD box or pickup point on the map.",
      boxRequired: "Choose a DPD box for delivery.",
    },
    locked: {
      tagline: "DROP 001 — COMING SOON",
      waitlist: "JOIN THE WAITLIST",
      days: "DAYS",
      hours: "HRS",
      minutes: "MIN",
      seconds: "SEC",
      emailPlaceholder: "Email address",
      notify: "SIGN UP",
      subscribed: "YOU'RE IN. KEEP WINNING",
      subscribedSub: "Early access + password will hit your inbox before the drop.",
      consent: "Early access + password. Plus news on future releases. Unsubscribe anytime.",
      privacy: "Privacy Policy",
      signupError: "SOMETHING WENT WRONG. TRY AGAIN.",
      enterPassword: "ENTER PASSWORD",
      passwordPlaceholder: "PASSWORD",
      unlock: "ENTER",
      wrong: "WRONG PASSWORD",
    },
    newsletter: {
      title: "JOIN THE WINNERS CLUB",
      sub: "First access to DROP 002, private sales and members-only colorways.",
      placeholder: "your@email.com",
      button: "JOIN NOW",
      loading: "JOINING...",
      success: "Welcome to the club. Victory incoming.",
      duplicate: "You are already in the club.",
      error: "Something went wrong. Try again.",
    },
    footer: {
      headings: { legal: "LEGAL", care: "CUSTOMER CARE", socials: "SOCIALS" },
      legal: ["Terms & Conditions", "Privacy Policy", "Cookie Settings"],
      care: ["Shipping Policy", "Refund Policy", "Size Guide", "Contact Us"],
      email: "info@winorwins.com",
      copyright: "© 2026 WINORWINS CLOTHING CO. ALL RIGHTS RESERVED.",
      made: "DESIGNED IN PRAGUE",
    },
  },
  cz: {
    nav: {
      home: "HOME",
      collection: "SHOP",
      contact: "KONTAKT",
    },
    hero: {
      line1: "THERE'S NO LOSING.",
      line2: "ONLY LEARNING OR",
      scriptWord: "Winning",
      cta: "PROZKOUMAT DROP 001",
      scroll: "SCROLLUJ",
    },
    products: {
      title: "BUILT FOR THE RELENTLESS",
      collectionTitle: "CELÁ KOLEKCE",
      viewAll: "CELÁ KOLEKCE",
      comingSoon: "Celá kolekce vychází brzy. Připoj se do klubu a dozvíš se to první.",
      colour: "Barva",
      colours: "Barvy",
      empty: "NOVÝ DROP JIŽ BRZY",
      loadError: "PRODUKTY JSOU DOČASNĚ NEDOSTUPNÉ",
    },
    product: {
      back: "ZPĚT",
      addToCart: "PŘIDAT DO KOŠÍKU",
      notFound: "PRODUKT NENALEZEN",
      notFoundSub: "Tenhle kus je pryč, nebo nikdy neexistoval.",
    },
    contact: {
      title: "KONTAKT",
      follow: "SLEDUJ NÁS",
      formName: "JMÉNO",
      formEmail: "EMAIL",
      formMessage: "ZPRÁVA",
      send: "ODESLAT ZPRÁVU",
      sending: "ODESÍLÁM...",
      success: "Zpráva odeslána. Brzy se ti ozveme.",
      error: "Něco se pokazilo. Zkus to znovu.",
    },
    lookbook: {
      title: "ARCHITEKTURA VÍTĚZSTVÍ",
      text: "Foceno na betonu. Stavěno do pohybu. Každý steh je rozhodnutí jít dopředu.",
    },
    social: {
      title: "NAŠE SOCIÁLNÍ SÍTĚ",
      sub: "Videa od našich ambasadorů vychází brzy. Označ #WINORWINS a buď featured.",
      comingSoon: "VIDEO BRZY",
      channels: [
        { platform: "INSTAGRAM", handle: "@winorwins.co", link: "https://instagram.com/winorwins.co" },
        { platform: "TIKTOK", handle: "@winorwins.co", link: "https://tiktok.com/@winorwins.co" },
      ],
    },
    cart: {
      title: "KOŠÍK",
      empty: "KOŠÍK JE PRÁZDNÝ",
      subtotal: "MEZISOUČET",
      checkout: "K POKLADNĚ",
      discountPlaceholder: "Slevový kód",
      apply: "POUŽÍT",
      remove: "ODEBRAT",
      soldOut: "VYPRODÁNO",
      added: "Přidáno do košíku.",
      unavailable: "Produkt je momentálně nedostupný.",
      error: "Něco se pokazilo. Zkus to znovu.",
      discountApplied: "Sleva použita",
      discountInvalid: "Neplatný slevový kód",
      shippingNote: "Doprava se spočítá u pokladny.",
      secure: "ZABEZPEČENÁ PLATBA KARTOU — TEYA",
    },
    checkout: {
      title: "POKLADNA",
      contact: "KONTAKT",
      email: "E-mail",
      phone: "Telefon",
      delivery: "DORUČOVACÍ ADRESA",
      firstName: "Jméno",
      lastName: "Příjmení",
      address1: "Ulice a číslo popisné",
      address2: "Byt, patro (nepovinné)",
      city: "Město",
      zip: "PSČ",
      country: "Země",
      shipping: "DOPRAVA",
      shippingHint: "Vyplň adresu a ukážeme ti možnosti dopravy.",
      shippingNone: "Na tuto adresu nedoručujeme. Zkontroluj ji, nebo nám napiš.",
      summary: "SHRNUTÍ OBJEDNÁVKY",
      subtotal: "MEZISOUČET",
      discount: "SLEVA",
      shippingCost: "DOPRAVA",
      free: "ZDARMA",
      total: "CELKEM",
      pay: "ZAPLATIT",
      paying: "PŘESMĚROVÁVÁME NA PLATBU…",
      agree: "Zaplacením souhlasíš s",
      terms: "obchodními podmínkami",
      and: "a",
      privacy: "zásadami ochrany osobních údajů",
      secure: "Platbu kartou bezpečně zpracovává Teya.",
      empty: "KOŠÍK JE PRÁZDNÝ",
      backToShop: "ZPĚT DO OBCHODU",
      cancelled: "Platba byla zrušena. Můžeš to zkusit znovu.",
      soldOut: "Něco z košíku se právě vyprodalo. Zkontroluj košík.",
      unavailable: "Platby teď nejsou dostupné. Zkus to prosím později.",
      error: "Něco se pokazilo. Zkontroluj údaje a zkus to znovu.",
      checking: "OVĚŘUJEME PLATBU…",
      paidTitle: "DĚKUJEME",
      paidText: "Platba přijata. Potvrzení objednávky ti posíláme na",
      order: "OBJEDNÁVKA",
      pendingText: "Ještě čekáme na potvrzení platby od banky. Jakmile dorazí, pošleme ti e-mail.",
      failedTitle: "PLATBA NEPROŠLA",
      failedText: "Z karty se nic nestrhlo. Zkus to znovu nebo použij jinou kartu.",
      expiredTitle: "PLATBA VYPRŠELA",
      tryAgain: "ZKUSIT ZNOVU",
      boxChoose: "VYBRAT BOX",
      boxChange: "ZMĚNIT",
      boxHint: "Vyber na mapě DPD box nebo výdejní místo.",
      boxRequired: "Vyber DPD box, kam ti balík pošleme.",
    },
    locked: {
      tagline: "DROP 001 — JIŽ BRZY",
      waitlist: "PŘIDEJ SE NA WAITLIST",
      days: "DNÍ",
      hours: "HOD",
      minutes: "MIN",
      seconds: "SEK",
      emailPlaceholder: "E-mailová adresa",
      notify: "SIGN UP",
      subscribed: "JSI UVNITŘ. KEEP WINNING",
      subscribedSub: "Early access + heslo ti přijde do e-mailu před dropem.",
      consent: "Early access + heslo. Navíc novinky o dalších dropech. Odhlásit se můžeš kdykoli.",
      privacy: "Ochrana osobních údajů",
      signupError: "NĚCO SE POKAZILO. ZKUS TO ZNOVU.",
      enterPassword: "ZADEJ HESLO",
      passwordPlaceholder: "HESLO",
      unlock: "VSTOUPIT",
      wrong: "ŠPATNÉ HESLO",
    },
    newsletter: {
      title: "PŘIPOJ SE DO WINNERS CLUBU",
      sub: "Přednostní přístup k DROP 002, privátní slevy a members-only colorwaye.",
      placeholder: "tvuj@email.cz",
      button: "PŘIPOJIT SE",
      loading: "PŘIPOJUJI...",
      success: "Vítej v klubu. Vítězství je na cestě.",
      duplicate: "Už jsi v klubu.",
      error: "Něco se pokazilo. Zkus to znovu.",
    },
    footer: {
      headings: { legal: "PRÁVNÍ", care: "ZÁKAZNICKÁ PÉČE", socials: "SOCIÁLNÍ SÍTĚ" },
      legal: ["Obchodní podmínky", "Ochrana osobních údajů", "Nastavení cookies"],
      care: ["Podmínky dopravy", "Vrácení zboží", "Tabulka velikostí", "Kontakt"],
      email: "info@winorwins.com",
      copyright: "© 2026 WINORWINS CLOTHING CO. VŠECHNA PRÁVA VYHRAZENA.",
      made: "NAVRŽENO V PRAZE",
    },
  },
};

const LanguageContext = createContext(null);

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState("en");
  return (
    <LanguageContext.Provider value={{ lang, setLang, t: translations[lang] }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLanguage() {
  return useContext(LanguageContext);
}
